"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientActive = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var recognition_1 = require("../../model/recognition");
var service_1 = require("../../../library/base/service");
var ClientActive = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ClientActive, _super);
    function ClientActive() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '人脸指纹识别激活接口';
        _this.code = '101045';
        _this.desc = '人脸指纹识别激活接口';
        _this.requestParams = new recognition_1.ClientActiveRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ClientActive;
}(service_1.BaseService));
exports.ClientActive = ClientActive;
//# sourceMappingURL=clientActive.js.map